let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page007_game2/img/bcg.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 279,
      y: 138,
    },
  },
  activeArea: {
    width: 60,
    height: 60,
    fontSize: 39,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '1',
      animation: true,
      textObj: {
        text: 'Kliknij w ikonę narzędzia <i>Wypełnij kolorem</i>.',
      },
      audio: {
        src: 'games/page007_game2/audio/z3s7-1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 554,
        y: 187,
      },
    },
    {
      id: '2',
      textObj: {
        text: 'Wybierz kolor z palety kolorów.',
      },
      audio: {
        src: 'games/page007_game2/audio/z3s7-2.mp3',
        //customowe ikony (bez obj icon lecą domyślne ;) )
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1211,
        y: 165,
      },
    },
    {
      id: '3',
      textObj: {
        text: 'Kliknij w element rysunku, który chcesz pokolorować.',
      },
      audio: {
        src: 'games/page007_game2/audio/z3s7-3.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1025,
        y: 458,
      },
    },
  ],
};
export default elements;
